// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__36W2N","messages":"Chat_messages__2WBP8","dateDivider":"Chat_dateDivider__Vc_2F"};